<template>
  <div class="detail">
    <div class="detail-banner">
      <div class="container">
        <h1 v-if="expert">{{ expert.name }}</h1>
      </div>
    </div>
    <div class="detail-body">
      <div class="container">
        <span class="detail-back" @click="$goBack()">‹ 返回</span>
        <div class="detail-content" v-if="expert">
          <div class="expert-avatar">
            <img v-if="expert.cover" :src="expert.cover" :alt="expert.name" @error="onImgError" />
            <span v-else>{{ expert.name.slice(0, 1) }}</span>
          </div>
          <section class="expert-block" v-if="expert.profile">
            <h3 class="block-title">专家简介</h3>
            <p>{{ expert.profile }}</p>
          </section>
          <section class="expert-block" v-if="expert.introduction">
            <h3 class="block-title">详细信息</h3>
            <div class="rich" v-html="expert.introduction"></div>
          </section>
        </div>
        <div class="detail-content" v-else-if="!loading">未找到该专家。</div>
        <div class="detail-content" v-else>加载中…</div>
      </div>
    </div>
  </div>
</template>

<script>
import { fetchExpertDetail } from '../api/home'

export default {
  name: 'ExpertDetail',
  props: ['id'],
  data () {
    return {
      expert: null,
      loading: true
    }
  },
  created () {
    this.load()
  },
  methods: {
    async load () {
      this.loading = true
      try {
        this.expert = await fetchExpertDetail(this.id)
      } catch (e) {
        this.expert = null
        this.$toast.show({ message: (e && e.message) || '加载失败', type: 'error' })
      } finally {
        this.loading = false
      }
    },
    onImgError (e) {
      e.target.style.display = 'none'
    }
  }
}
</script>

<style scoped>
.expert-avatar {
  width: 220px;
  max-width: 100%;
  min-height: 220px;
  margin: 0 auto 24px;
  border: 1px solid #e6ebf5;
  border-radius: 14px;
  background: #f4f7fe;
  color: var(--primary);
  font-size: 64px;
  font-weight: 800;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}
.expert-avatar img {
  max-width: 100%;
  max-height: 320px;
  object-fit: contain;
  display: block;
}
.expert-block {
  background: #fff;
  border: 1px solid var(--border, #e6ebf5);
  border-radius: 12px;
  padding: 20px 22px;
  margin-bottom: 18px;
}
.block-title {
  position: relative;
  padding-left: 14px;
  margin: 0 0 12px;
  font-size: 17px;
  font-weight: 800;
  color: #1f2a44;
}
.block-title::before {
  content: '';
  position: absolute;
  left: 0;
  top: 2px;
  bottom: 2px;
  width: 4px;
  border-radius: 2px;
  background: var(--primary, #2444cb);
}
.expert-block p {
  margin: 0;
  color: #33415c;
  line-height: 1.9;
}
.rich {
  line-height: 1.8;
  color: #33415c;
}
.rich ::v-deep p {
  margin: 0 0 10px;
}
</style>
